const prism = () => ({
  '& .prism-code': {
    fontFamily: 'monospace !important',
    tabSize: '2 !important',
    padding: '0 !important',
  },
});

export default prism;
